module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor25.3c8595b5.png";